import { useQuery } from '@tanstack/react-query';
import {
  listActiveContactos,
  type ContactoItem,
} from '@/shared/api/controllers/contactos';

export const CONTACTOS_QUERY_KEY = ['contactos', 'active'] as const;

export function useActiveContactos() {
  return useQuery<ContactoItem[]>({
    queryKey: CONTACTOS_QUERY_KEY,
    queryFn: listActiveContactos,
    staleTime: 60_000,
  });
}
